import React, { useState } from 'react';
import { useLayoutBreakpoint } from '../../../hooks/use-layout-breakpoint';
import { Card } from '../card/card';

const MappedCards = ({ subsection, data }) => {
  const [hover, setHover] = useState(null);

  const isHovered = (id) => hover === subsection + id;
  const setHoverIndex = (id) => subsection + id;

  const breakpoint = useLayoutBreakpoint();

  const mappedCards = data?.map((article) => (
    <div
      key={article._id}
      className="d-flex flex-row justify-content-center p-3"
      onMouseOut={() => setHover(null)}
      onBlur={() => setHover(null)}
      onMouseOver={() => setHover(setHoverIndex(article._id))}
      onFocus={() => setHover(setHoverIndex(article._id))}
    >
      <Card isHovered={isHovered(article._id)} article={article} />
    </div>
  ));

  const mappedCardsMobile = data?.map((article, index) => (
    <div
      key={article._id}
      onMouseOut={() => setHover(null)}
      onBlur={() => setHover(null)}
      onMouseOver={() => setHover(setHoverIndex(article._id))}
      onFocus={() => setHover(setHoverIndex(article._id))}
      className={`d-flex flex-row justify-content-center ${
        index !== data?.length - 1 ? 'mb-4' : ''
      } ${index !== 0 ? 'mt-5' : ''}`}
    >
      <Card isHovered={isHovered(article._id)} article={article} />
    </div>
  ));

  return (
    <>
      {breakpoint === 'xs' || breakpoint === 'sm' || breakpoint === 'md' ? (
        <div className="d-flex flex-column">{mappedCardsMobile}</div>
      ) : (
        <div className="row justify-content-md-around">{mappedCards}</div>
      )}
    </>
  );
};

export { MappedCards };
